import { defineComponent as h, computed as d, openBlock as l, createBlock as y, resolveDynamicComponent as b, normalizeStyle as x, withCtx as C, createElementBlock as z } from "vue";
import { KUI_ICON_SIZE_50 as c } from "./kong-icons.es1628.js";
const N = ["aria-hidden"], u = '<path d="M5 19H6.4L15.025 10.375L13.625 8.975L5 17.6V19ZM19.3 8.925L15.05 4.725L16.45 3.325C16.8333 2.94167 17.3042 2.75 17.8625 2.75C18.4208 2.75 18.8917 2.94167 19.275 3.325L20.675 4.725C21.0583 5.10833 21.2583 5.57083 21.275 6.1125C21.2917 6.65417 21.1083 7.11667 20.725 7.5L19.3 8.925ZM17.85 10.4L7.25 21H3V16.75L13.6 6.15L17.85 10.4Z" fill="currentColor"/>', q = /* @__PURE__ */ h({
  __name: "EditIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: c,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (i) => {
        if (typeof i == "number" && i > 0)
          return !0;
        if (typeof i == "string") {
          const e = String(i).replace(/px/gi, ""), r = Number(e);
          if (r && !isNaN(r) && Number.isInteger(r) && r > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(i) {
    const e = i, r = d(() => {
      if (typeof e.size == "number" && e.size > 0)
        return `${e.size}px`;
      if (typeof e.size == "string") {
        const n = String(e.size).replace(/px/gi, ""), t = Number(n);
        if (t && !isNaN(t) && Number.isInteger(t) && t > 0)
          return `${t}px`;
      }
      return c;
    }), g = d(() => ({
      boxSizing: "border-box",
      color: e.color,
      display: e.display,
      flexShrink: "0",
      height: r.value,
      lineHeight: "0",
      width: r.value,
      pointerEvents: e.decorative ? "none" : void 0
    })), p = (n) => {
      const t = {}, S = Math.random().toString(36).substring(2, 12);
      return n.replace(/id="([^"]+)"/g, (s, o) => {
        const a = `${S}-${o}`;
        return t[o] = a, `id="${a}"`;
      }).replace(/#([^\s^")]+)/g, (s, o) => t[o] ? `#${t[o]}` : s);
    }, f = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, m = (n) => n.replace(/[<>"'&]/g, (t) => f[t]), v = `${e.title ? `<title data-testid="kui-icon-svg-title">${m(e.title)}</title>` : ""}${e.staticIds ? u : p(u)}`;
    return (n, t) => (l(), y(b(i.as), {
      "aria-hidden": i.decorative ? "true" : void 0,
      class: "kui-icon edit-icon",
      "data-testid": "kui-icon-wrapper-edit-icon",
      style: x(g.value),
      tabindex: i.decorative ? "-1" : void 0
    }, {
      default: C(() => [
        (l(), z("svg", {
          "aria-hidden": i.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-edit-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: v
        }, null, 8, N))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
});
export {
  q as default
};
